import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TSendInvoiceEmailRequest,
  TSendInvoiceEmailResponse,
} from "./sendInvoiceEmail.schema";

export const sendInvoiceEmail =
  (axios: IAxiosInstance) => async (body: TSendInvoiceEmailRequest) => {
    const response = await axios.noRetry.post<
      IApiResponse<TSendInvoiceEmailResponse>
    >("/api/invoices/send-email", body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
